function encodeGetParams (p, useArrays = true) {
    const result = [];
    const entries = Object.entries(p);
  
    entries.forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          result.push(`${key}${useArrays ? '[]' : ''}=${encodeURIComponent(item)}`);
        });
      } else {
        result.push(`${key}=${encodeURIComponent(value)}`);
      }
    });
  
    return result.join('&');
  }

export default {
    encodeGetParams
};